import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverRegistrationResponseDTO,
  DriverRequestDTO
} from '../../interfaces/apiInterfaces';

export class UpdateDriverCommand extends IRequestCommand<
  IUpdateDriver,
  ErrorDetails,
  IUpdateDriverCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'drivers/{id}';
  public override setParameters(parameters: IUpdateDriverCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{id}',
      parameters.idDriver.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUpdateDriverCommandParameters
  extends ICommandParameters,
  DriverRequestDTO {
  idDriver?: number;
}

export interface IUpdateDriver
  extends DriverRegistrationResponseDTO,
  ICommandResponse { }
